import { render, staticRenderFns } from "./showAggregatePeriod.vue?vue&type=template&id=0ca0b3b1"
import script from "./showAggregatePeriod.vue?vue&type=script&lang=js"
export * from "./showAggregatePeriod.vue?vue&type=script&lang=js"
import style0 from "./showAggregatePeriod.vue?vue&type=style&index=0&id=0ca0b3b1&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports